import { render, staticRenderFns } from "./ContactPersonForm.vue?vue&type=template&id=a10aa746&scoped=true&"
import script from "./ContactPersonForm.vue?vue&type=script&lang=js&"
export * from "./ContactPersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10aa746",
  null
  
)

export default component.exports